<template>
  <v-container class="max-width-1200">

    <v-row>
      <v-col  cols="12" md="7">
        <v-row>
          <v-col class="pb-0 headline text-uppercase">
            {{ $t('career.title') }}
          </v-col>
        </v-row>
        <v-row>
          <v-col class="display-1">
            {{ $t('career.subtitle')}}
          </v-col>
        </v-row>
        <v-row>
          <v-col class="text-justify">
            {{ $t('career.pros.text.01')}}
          </v-col>
        </v-row>
        <v-row>
          <v-col>
            <v-btn
              color="primary"
              depressed
              tile
              @click="loadPage('Career')">
                {{ $t("common.intrested") }}
            </v-btn>
          </v-col>
        </v-row>
      </v-col>
      <v-col  cols="12" md="5" class="align-center d-flex">
        <v-img
          src="@/assets/img/rubin-img-06.jpg"
          cover
          min-height="300"
          class="ml-auto">
        </v-img>
      </v-col>
    </v-row>

    <v-row justify="center">
      <v-col>
      </v-col>
    </v-row>

  </v-container>
</template>

<script>
  import DataComponentBase from '@/commons/DataComponentBase';

  export default {
    name: 'Awards',
    extends: DataComponentBase,

    data: () => ({
    }),

    methods: {

    },
  }
</script>
